import service from "auth/FetchInterceptor";

const AuthService = {}

AuthService.login = function (data) {
	return service({
		url: '/login',
		method: 'post',
		data: data
	})
}

AuthService.register = function (data) {
	return service({
		url: '/auth/register',
		method: 'post',
		data: data
	})
}

AuthService.logout = function () {
	return true
}

AuthService.loginInOAuth = function () {
	return service({
		url: '/auth/loginInOAuth',
		method: 'post'
	})
}

export default AuthService;